export default {
  hero: {
    "are-you-a-supplier": "Je suis un fournisseur ?",
    "new-material": "Nouveau matériel",
    title: "Acheter votre matériel n'a jamais été aussi simple",
    description:
      "Le meilleur outil des installateurs pour optimiser leurs achats et leur gestion d’entrepôt.",
    "try-now": "Essayer maintenant",
  },
  values: {
    object: "Fonctionnalités",
    title: "Économiser +10% sur vos coûts d’approvisionnement",
    description:
      "Quis tellus eget adipiscing convallis sit sit eget aliquet quis. Suspendisse eget egestas a elementum pulvinar et feugiat blandit at. In mi viverra elit nunc.",
    features: {
      quote: {
        title: "Demande de devis auprès des fournisseurs",
        description:
          "Envoyez en 1 clic vos listes de matériel directement à vos contacts chez vos fournisseurs pour accélerer vos demandes de devis.",
      },
      buying: {
        title: "Accès à des produits pour achat immédiat",
        description:
          "Explorez une sélection de produits disponibles à l'achat immédiat en ligne, sans attentes ni formalitérs, pour gagner du temps et de l'argent.",
      },
      delivery: {
        title: "Suivi des livraisons",
        description:
          "Gardez un œil en temps réel sur l'état de vos commandes et suivez chaque étape de la livraison jusqu'à la réception de votre matériel.",
      },
      references: {
        title: "10000+ références produits",
        description:
          "Choisissez vos modules, onduleurs, coffrets, batteries ... depuis notre base de données mise à jour en temps réel. Intégrée avec devis et démarches.",
      },
      integration: {
        title: "Intégration facile du matériel de vos chantiers",
        description:
          "Planification automatique des listes d'équipements pour vos installations photovoltaïques à partir de vos études et dossiers urbanisme.",
      },
      historic: {
        title: "Historique des commandes",
        description:
          "Accédez à un historique complet de vos commandes passées pour suivre vos achats et gérer vos stocks plus efficacement.",
      },
    },
  },
  reservations: {
    badgeText: "Achat groupé",
    title:
      "Achetez votre matériel photovoltaïque auprès de la centrale d'achat la plus compétitive du marché",
    description:
      "Bénéficiez de prix de gros et limiter vos frais de livraison, avec nos réductions avantageuses en rejoignant notre programme d'achat groupé. En regroupant les commandes, le processus d'achat est simple pour les fournisseurs et économique pour les acheteurs.",
    advantages: {
      title:
        "Voici pourquoi cette approche est avantageuse et comment elle fonctionne en trois étapes simples.",
      price: {
        title: "Prix 30% moins chers",
        description:
          "L'achat groupé permet de réduire considérablement les coûts en négociant des tarifs préférentiels grâce à des commandes combinées.",
      },
      quality: {
        title: "Produits innovants de qualité",
        description:
          "Les fournisseurs privilégient les commandes groupées en proposant des produits de haute qualité à prix réduits.",
      },
      simplicity: {
        title: "Simplification de la logistique",
        description:
          "L'achat groupé optimise la gestion en centralisant les commandes. Moins de livraisons et des économies sur vos frais de port.",
      },
    },
  },
  checkout: {
    title: "Catalogue de +10000 modèles",
    "see-more": "Voir toute la sélection",
    database: "Base de donnée",
  },
  simplicity: {
    object: "Optimisation",
    title: "Intégration facile du matériel prévu dans vos projets",
    paragraph1:
      "Notre solution facilite l'intégration du matériel prévu dans vos projets dès la phase de planification. Vous pouvez attribuer le matériel à différents projets ou devis de vos clients même avant sa réception.",
    paragraph2:
      "Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux projets en cours, ce qui simplifie la préparation et l'organisation de vos projets.",
    paragraph3:
      "Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque projet dispose des équipements nécessaires dès que les besoins sont définis.",
    "try-now": "Essayez maintenant",
  },
  logistics: {
    object: "Livraison",
    title: "Suivi de vos livraisons en temps réel",
    description:
      "Notre service de suivi vous permet de surveiller vos livraisons de matériel photovoltaïque en temps réel. Grâce à notre système de traçabilité avancé, vous recevez des mises à jour instantanées sur l'état de votre commande, depuis l'expédition jusqu'à la livraison finale. Vous pouvez consulter l'emplacement actuel de votre matériel, prévoir les délais de réception, et être informé de toute éventuelle modification ou retard. Ce suivi transparent et précis vous offre une tranquillité d'esprit, vous permettant de mieux planifier l'installation de vos équipements photovoltaïques et d’assurer une gestion efficace de votre projet.",
    timeline: {
      step1: "Préparation et emballage du matériel pour l'expédition.",
      step2: "Expédition du matériel par l'expéditeur.",
      step3: "Transport du matériel vers le centre de distribution.",
      step4: "Traitement du matériel au centre de distribution.",
      step5: "Livraison du matériel à l'adresse de destination.",
      step6: "Confirmation de réception.",
    },
  },
  "data-driven": {
    "down-stream-sales-title": "Piloté par les données",
    "down-stream-sales-desc":
      "Nous serons la première place de marché à exploiter des informations basées sur les données pour faciliter les ventes de matériel. Notre plateforme héberge déjà une vaste base de données de matériel solaire avec plus de 10 000 produits. En utilisant des données sur les quantités de matériel en temps réel provenant de notre réseau d'installateurs - nos clients saisissent quotidiennement des modèles et des quantités précis lorsqu'ils utilisent les solutions projetsolaire - nous visons à optimiser en temps réel l'alignement de l'offre de matériel avec la demande.",
    "coming-soon": "Bientôt disponible",
    "purchase-suggestion-title": "Suggestions d'achat",
    "purchase-suggestion-desc":
      "Notre place de marché sera l'une des premières plateformes de e-commerce multi-fournisseurs en France, à l'instar de ce que SolarTraders ou Solar Clarity ont introduit avec succès sur d'autres marchés européens. Nous avons déjà obtenu une vaste gamme de listes de produits pour panneaux solaires, onduleurs, batteries et plus encore (plus que toute autre boutique en ligne en France), grâce à un partenariat avec un fournisseur basé à Rotterdam.",
    "human-in-loop-title": "Humain dans la boucle",
    "human-in-loop-desc":
      "Nous garderons l'humain dans la boucle, en mettant l'accent sur le rôle de conseil des représentants commerciaux en matériel et en aidant les équipes de vente de matériel à augmenter leurs revenus via notre plateforme. Notre mission est de réduire le coût de l'énergie solaire - tout en favorisant l'innovation numérique en France. Nous espérons pouvoir réduire les coûts de vente et de commercialisation - en minimisant les frictions pour promouvoir les meilleures offres directement auprès de nos milliers d’installateurs et développeurs.",
    "data-driven": "Piloté par les données",
    "sales-2024": "Ventes en 2024",
  },

  shop: {
    banner: {
      "promotion-messages": {
        "fast-delivery": "Livraison rapide sur les produits listés",
        "secure-payments":
          "Paiements en ligne sécurisés pour tous les fournisseurs",
        "new-products":
          "Nouveaux produits ajoutés chaque semaine - Découvrez-les !",
      },
      links: {
        about: "À propos de nous",
        blog: "Blog",
        help: "FAQ",
        support: "Assistance",
      },
    },
  },
  footer: {
    newsletter: {
      title: "Abonnez-vous à notre newsletter",
      subtitle:
        "Inscrivez-vous à notre newsletter pour rester informé des nouveautés et des mises à jour",
      placeholder: "Entrez votre adresse e-mail",
      button: "S'abonner",
    },
    company: {
      name: "L'Entrepôt",
      by: "Par",
      poweredBy: "projetsolaire",
    },
    contact: {
      phone: "+33 7 44 09 61 13",
      hours: "Mon - Fri 09:00 - 17:00 CET",
      rates: "Prix d'appel selon les tarifs de l'opérateur.",
    },
    sections: {
      contact: "Contact",
      categories: "Catégories",
      brands: "Brands",
    },
    legal: {
      disclaimer: "Déclaration légale",
      privacyPolicy: "Politique de confidentialité",
      termsAndConditions: "Conditions d'utilisation",
    },
  },
}
